import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

const NetworkSecurity = () => {
  useEffect(() => {
    Aos.init({ duration: 1200, once: true });
  }, []);

  return (
    <section className="min-h-screen bg-blue-950 text-black py-16 px-6 sm:px-10 lg:px-20">
      <div className="max-w-7xl mx-auto space-y-16">
        {/* Hero */}
        <div data-aos="fade-up" className="text-center">
          <h2 className="text-4xl font-bold font-poppins text-sky-400">
            Network Security
          </h2>
          <p className="text-lg text-white mt-4 font-inter">
            Protect your network and empower your team with proactive security and support.
          </p>
        </div>

        {/* Services */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center" data-aos="fade-right">
          <img
            src="/servicepages/Network-Security.jpg"
            alt="Network Shield"
            className="w-full h-auto rounded-lg shadow-md object-cover"
          />
          <div className="space-y-4">
            <h3 className="text-2xl font-semibold text-sky-400 font-poppins">
              What We Protect
            </h3>
            <ul className="list-disc pl-5 text-white space-y-2 font-inter">
              <li>Firewall & intrusion detection systems</li>
              <li>Endpoint & antivirus management</li>
              <li>Secure VPN and remote connectivity</li>
              <li>End-to-end LAN & WAN infrastructure setup</li>
              <li>Structured cabling and network rack solutions</li>
              <li>Router, switch, firewall, and access point installation</li>
              
            </ul>
          </div>
        </div>

       

       {/* CTA */}
        <div className="text-center">
          <a
            href="/contact"
            className="inline-block bg-gray-50 text-blue-950 px-8 py-3 rounded-md font-semibold hover:text-sky-400 transition"
          >
            Talk to Our Experts
          </a>
        </div>
      </div>
    </section>
  );
};

export default NetworkSecurity;
